import { render, staticRenderFns } from "./EditConversation.vue?vue&type=template&id=36ac9bae"
import script from "./EditConversation.vue?vue&type=script&lang=js"
export * from "./EditConversation.vue?vue&type=script&lang=js"
import style0 from "./EditConversation.vue?vue&type=style&index=0&id=36ac9bae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports